"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RtfDocumentProperties = void 0;
var code_pages_1 = require("../encoding/code-pages");
var enums_1 = require("./character/enums");
var color_collections_1 = require("./color-collections");
var RtfDocumentProperties = (function () {
    function RtfDocumentProperties() {
        this.charset = enums_1.RtfCharset.Ansi;
        this.defaultCodePage = code_pages_1.CodePages.default;
        this.colorIndexes = new color_collections_1.RtfColorIndexCollection();
        this.listTable = [];
        this.listOverrideTable = [];
    }
    return RtfDocumentProperties;
}());
exports.RtfDocumentProperties = RtfDocumentProperties;
